import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const ImporterRetrieveCriteriaSchema = z.object({
  pagination: z.object({
    page: z.number(),
    size: z.number(),
  }),
  filters: z
    .object({
      searchQuery: z.string().optional(),
      declarant: z.string().optional(),
    })
    .optional(),
});

export type ImporterRetrieveCriteria = z.infer<typeof ImporterRetrieveCriteriaSchema>;

export const importerContract = c.router({
  retrieveImporters: {
    method: 'POST',
    path: '/importer/retrieve-importers',
    body: z.object({
      criteria: ImporterRetrieveCriteriaSchema,
    }),
    responses: {
      200: z.object({
        importers: z.array(z.any()),
      }),
    },
  },
  retrieveImportersMetadata: {
    method: 'POST',
    path: '/importer/retrieve-importers-metadata',
    body: z
      .object({
        searchQuery: z.string().optional(),
      })
      .passthrough(),
    responses: {
      200: z.object({
        metadata: z.object({
          total: z.number(),
        }),
      }),
    },
  },
  retrieveImporterDetails: {
    method: 'GET',
    path: '/importer/retrieve-importer-details/:id',
    pathParams: z.object({
      id: z.string(),
    }),
    responses: {
      200: z.object({
        importer: z.any(),
      }),
    },
  },
  generateDocument: {
    method: 'POST',
    path: '/importer/generate-document/:id/:type',
    pathParams: z.object({
      id: z.string(),
      type: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
        fileName: z.string(),
      }),
    },
  },
  deleteDocument: {
    method: 'POST',
    path: '/importer/delete-document/:id/:fileName',
    pathParams: z.object({
      id: z.string(),
      fileName: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
        fileName: z.string(),
      }),
    },
  },
  downloadDocument: {
    method: 'GET',
    path: '/importer/download-document/:id/:fileName',
    pathParams: z.object({
      id: z.string(),
      fileName: z.string(),
    }),
    responses: {
      200: z.any(),
    },
  },
  sendPoa: {
    method: 'POST',
    path: '/importer/send-poa/:id',
    pathParams: z.object({
      id: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
  sendVat: {
    method: 'POST',
    path: '/importer/send-vat/:id',
    pathParams: z.object({
      id: z.string(),
    }),
    body: c.noBody(),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
});
